import { trackError } from '@proposify/frontend-observability';
import { getPermissions, getPermissionsQueryResponseSchema } from '@proposify/users-bff-api-client';
import { getUserServiceSchemaClientConfig } from 'services/api/client';
import type { PermissionsResult } from './types';

const FALLBACK_PERMISSIONS_RESPONSE: PermissionsResult = {
  permissions: {
    custom_role_access: { allowed: false, denyReasons: [] },
    access_settings: { allowed: false },
    access_billing: { allowed: false },
    purchase_collaborator_seats: { allowed: false },
    access_users: { allowed: false },
    access_content_library: { allowed: false },
    share_document: { allowed: false },
    edit_document: { allowed: false },
    edit_documents: { allowed: false },
    access_automations: { allowed: true },
    create_automations: { allowed: false },
    access_integrations: { allowed: true },
    view_documents: { allowed: true },
    access_pricing_catalog: { allowed: false },
    manage_pricing_catalog: { allowed: false },
  },
  source: 'fallback',
};

export const ApiUsersPermissionsRepository = {
  getPermissions: async (): Promise<PermissionsResult> => {
    try {
      const permissions = getPermissionsQueryResponseSchema.parse(await getPermissions(getUserServiceSchemaClientConfig()));
      return { permissions, source: 'server' };
    } catch (error) {
      trackError(error, { service: 'userService', operation: 'getUserPlanPermissions' });
      return FALLBACK_PERMISSIONS_RESPONSE;
    }
  },
};
